import { useCallback, useEffect, useState } from 'react';
import { Room } from 'types/room';
import { getLocationLevelFive } from 'services/locations';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

export const useInfoRoom = (roomId?: number) => {
  const [room, setRoom] = useState<Room>();

  const handleGetLocationLevelFive = useCallback(async (roomId: number) => {
    if (!roomId) return;
    const data = await getLocationLevelFive(Number(roomId));
    setRoom(data.room);
  }, []);

  const { asyncCallback: asyncHandleGetLocationLevelFive } = useAsyncCallback(
    handleGetLocationLevelFive,
    []
  );
  useEffect(() => {
    if (!roomId) return;
    asyncHandleGetLocationLevelFive(roomId);
  }, [roomId, asyncHandleGetLocationLevelFive]);

  return {
    room,
    asyncHandleGetLocationLevelFive
  };
};
